import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Button,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { ErrorContext } from '../context/ErrorContext';
import { createAxiosInstance } from '../api/axios';
import EvaluationsSection from '../components/EvaluationsSection';
import JobInfoSection from '../components/JobInfoSection';

const MyApplicationPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  // const { user } = useContext(AuthContext);
  const { setError } = useContext(ErrorContext);
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);

  const authAxios = useMemo(() => {
    return createAxiosInstance(null);
  }, []);

  const fetchApplication = async () => {
    try {
      setLoading(true);
      const response = await authAxios.get(`/application/${id}/`);
      setApplication(response.data);
    } catch (error) {
      if (error.response?.status === 404) {
        setError("Application not found");
      } else {
        setError("Failed to load application details");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchApplication();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <CircularProgress size={60} sx={{ color: 'primary.main', mb: 2 }} />
        <Typography variant="h6" sx={{ color: 'text.primary' }}>
          Loading Application Details
        </Typography>
      </Box>
    );
  }

  if (!application) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: 'white',
          p: 4,
        }}
      >
        <Alert severity="error">
          Application not found or you don't have permission to view it.
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'white',
        py: 4,
        px: 3,
        maxWidth: '100%',
      }}
    >
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/dashboard')}
          sx={{
            mb: 2,
            color: 'primary.main',
            textTransform: 'none',
            fontWeight: 500,
          }}
        >
          Back to Dashboard
        </Button>
        
        <Typography variant="h4" fontWeight="bold" sx={{ color: 'black', mb: 1 }}>
          Application Details
        </Typography>
      </Box>

      <Grid container spacing={4} sx={{ width: '100%' }}>
        {/* Left Column - Evaluations (75%) */}
        <Grid item xs={12} lg={9} md={8}>
          <EvaluationsSection application={application} />
        </Grid>

        {/* Right Column - Job & Application Info (25%) */}
        <Grid item xs={12} lg={3} md={4}>
          <JobInfoSection application={application} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default MyApplicationPage;